// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".education-center__title[data-v-3c46202f]{margin-bottom:40px}@media (max-width:767px){.education-center__title[data-v-3c46202f]{margin-bottom:20px}}.education-center__telegram[data-v-3c46202f]{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
